/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Section_SourceInputs */

const en_admin_funnel_section_source = /** @type {(inputs: Admin_Funnel_Section_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By first-touch source`)
};

/**
* | output |
* | --- |
* | "By first-touch source" |
*
* @param {Admin_Funnel_Section_SourceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_section_source = /** @type {((inputs?: Admin_Funnel_Section_SourceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Section_SourceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_section_source(inputs)
});
export { admin_funnel_section_source as "admin.funnel.section.source" }